import { SimpleGrid, Text } from '@chakra-ui/react';

import { StatCard } from '@aslanpay/portal-common-lib';

import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import { ModulesOverview } from 'app/components/Dashboard/ModulesOverview';
import { PayScheduleSection } from 'app/components/Dashboard/PayScheduleSection';

import useFetchCompanyPot from 'app/hooks/useFetchCompanyPot';
import useFetchCompanyStats from 'app/hooks/useFetchCompanyStats';
import useFetchCompanyTransactionsTotal from 'app/hooks/useFetchCompanyTransactionsTotal';
import useFetchPayCalendars from 'app/hooks/useFetchPayCalendars';

import { useManagingCompanyStore } from 'app/store';

import formatNumber from 'app/utils/formatting';
import getPointsValue from 'app/utils/points';
import { formatCurrency } from 'app/utils/strings';

function Dashboard() {
  const { company } = useManagingCompanyStore.getState();
  const companyId = company?.id;

  const { data: stats, isLoading: isLoadingStats } = useFetchCompanyStats(companyId);
  const { data: transactionsTotal, isLoading: isLoadingTransactions } =
    useFetchCompanyTransactionsTotal(companyId);
  const { data: companyPot, isLoading: isLoadingPot } = useFetchCompanyPot(companyId);
  const { data: payCalendars, isLoading: isLoadingPayCalendars } = useFetchPayCalendars({
    companyId: [companyId || ''],
    status: ['ACTIVE'],
    page: 0,
    size: 50,
  });

  const activePayCalendars = payCalendars?.list ?? [];
  const currency = activePayCalendars[0]?.currency ?? 'GBP';

  const totalEmployees = isLoadingStats || !stats ? '—' : stats.individualStats.totalCount;
  const activeEmployees = isLoadingStats || !stats ? '—' : stats.individualStats.activeCount;
  const totalTransactions =
    isLoadingTransactions || transactionsTotal === undefined
      ? '—'
      : formatCurrency(transactionsTotal, currency);
  const companyPotPoints = isLoadingPot ? '—' : `${formatNumber(companyPot?.balance ?? 0)} pts`;
  const companyPotValue = isLoadingPot
    ? undefined
    : `≈ ${formatCurrency(getPointsValue(companyPot?.balance ?? 0), currency)}`;

  return (
    <AuthenticatedPageWrapper title="Dashboard">
      <Text as="h2" textStyle="h2" color="brand.darkPurple">
        Dashboard
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing="20px" mt="10px">
        <StatCard title="Total employees" value={totalEmployees} />
        <StatCard title="Active employees" value={activeEmployees} />
        <StatCard
          title="Total transactions"
          value={totalTransactions}
          description="Settled spend to date"
        />
        <StatCard title="Company pot" value={companyPotPoints} description={companyPotValue} />
      </SimpleGrid>

      <ModulesOverview companyId={companyId} />

      <PayScheduleSection payCalendars={activePayCalendars} isLoading={isLoadingPayCalendars} />
    </AuthenticatedPageWrapper>
  );
}

export default Dashboard;
